<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>用户管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/judgeList')">银行卡列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='关键词'>
            <el-input
              style="width:200px"
              v-model="filters.keywords"
              placeholder="请输入评价内容或者用户昵称"
            >
            </el-input>
          </el-form-item>
          <el-form-item label='商品名称或者id'>
            <el-input
              style="width:200px"
              v-model="filters.good_key"
              placeholder="请输入商品名称或者id"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="推荐类型">
            <el-select
              v-model="filters.reco_type"
              clearable
            >
              <el-option
                label="图片"
                value="1"
              ></el-option>
              <el-option
                label="视频"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="username"
            label="用户姓名"
          >
          </el-table-column>
          <el-table-column
            prop="good_name"
            label="商品名称"
          >
          </el-table-column>

          <el-table-column label="用户图片">
            <template slot-scope="scope">
              <img
                :src="scope.row.user_head"
                style="width:50px;height:50px"
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="title"
            label="评价内容"
            width="200px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>

          <el-table-column
            prop="info_type"
            label="素材类型"
          >
            <template slot-scope="scope">

              <el-tag
                v-if="scope.row.info_type == 1"
                type="success"
                disable-transitions
              >图片</el-tag>
              <el-tag
                v-if="scope.row.info_type == 2"
                disable-transitions
              >视频</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="视频" width="300px">
            <template slot-scope="scope">
              <video v-if="scope.row.info_type == 2" style="width:300px;height:210px" :src="scope.row.video_url" class="avatar" controls="controls">您的浏览器不支持视频播放</video>
            </template>
          </el-table-column>

          <el-table-column
            label="图片"
          >
          <template slot-scope="scope">
              <el-button
                v-if="scope.row.info_type == 1"
                @click="showSecond(scope.row)"
                type="text"
                size="small"
              >查看图片</el-button>
          </template>
          </el-table-column>

          <el-table-column
            prop="title_num"
            label="文字复制次数"
          >
          </el-table-column>

          <el-table-column
            prop="media_num"
            label="视频图片复制次数"
          >
          </el-table-column>

          <el-table-column
            prop="status"
            label="上架状态"
          >
            <template slot-scope="scope">

              <el-tag
                v-if="scope.row.status == 2"
                type="success"
                disable-transitions
              >是</el-tag>
              <el-tag
                v-if="scope.row.status == 1"
                type="info"
                disable-transitions
              >否</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.status == 1">
                <el-button
                  @click="upHouseStatus(scope.row,2)"
                  type="text"
                  size="small"
                >上架</el-button>
              </template>
              <template v-if="scope.row.status == 2">
                <el-button
                  @click="upHouseStatus(scope.row,1)"
                  type="text"
                  size="small"
                >下架</el-button>
              </template>
              <el-button
                @click="upHouseStatus(scope.row,3)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
var _ = require("lodash");
export default {
  name: "user_bank_list",
  created() {
  },

  data() {
    return {
      picList:[],
      dialogAddVisible:false,
      filters: {
        keywords: null,
        reco_type: null,
        good_key:null
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    upHouseStatus(row, status) {
      if (status == 3) {
        let that = this;
        this.$confirm("确定删除该素材吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              ids: row.id,
              status: 2
            };
            API.del_judge(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 1) {
        let that = this;
        this.$confirm("确定下架该素材吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.down_judge(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "下架成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else {
        let that = this;
        this.$confirm("确定上架该素材吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.push_judge(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "上架成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    showSecond(row){

    },
    search() {
      let that = this;
      let params = {
        page_num: that.page_num,
        page_size: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.reco_type) {
        params.info_type = that.filters.reco_type;
      }
      if (that.filters.keywords) {
        params.keywords = that.filters.keywords;
      }
      if (that.filters.good_key) {
        params.good_key = that.filters.good_key;
      }

      that.loading = true;
      API.judge_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                // for (var i=0; i<result.list.length; i++)
                // {
                //   result.list[i].properties =
                // }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>

.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/user_bank_list.vue